import React from 'react';

import { NavContext } from '../contexts/NavContext';

import type { FamilyReactProps } from './FamilyReactProps';
import { FmlIconInner } from './inner-proxies';
import { createForwardRef, getConfig } from './utils';

interface FmlIconProps {
  color?: string;
  flipRtl?: boolean;
  icon?: string;
  ios?: string;
  lazy?: boolean;
  md?: string;
  mode?: 'ios' | 'md';
  name?: string;
  size?: string;
  src?: string;
}

type InternalProps = FmlIconProps & {
  forwardedRef?: React.ForwardedRef<HTMLFmlIconElement>;
};

class FmlIconContainer extends React.PureComponent<InternalProps> {
  constructor(props: InternalProps) {
    super(props);
    if (this.props.name) {
      console.warn(
        'In Family React, you import icons from "famicons/icons" and set the icon you imported to the "icon" property. Setting the "name" property has no effect.'
      );
    }
  }

  render() {
    const { icon, ios, md, mode, ...rest } = this.props;

    let iconToUse: typeof icon;

    const config = getConfig();
    const iconMode = mode || config?.get('mode');

    if (ios || md) {
      if (iconMode === 'ios') {
        iconToUse = ios ?? md ?? icon;
      } else {
        iconToUse = md ?? ios ?? icon;
      }
    } else {
      iconToUse = icon;
    }

    return (
      <FmlIconInner ref={this.props.forwardedRef} icon={iconToUse} {...rest}>
        {this.props.children}
      </FmlIconInner>
    );
  }

  static get contextType() {
    return NavContext;
  }
}

export const FmlIcon = createForwardRef<FmlIconProps & FamilyReactProps, HTMLFmlIconElement>(
  FmlIconContainer,
  'FmlIcon'
);
